import { compareAlphanumeric } from "./employeeUtils";

export const filterEmployees = (
  employees,
  selectedFilter
) => {
  let filteredAndSortedEmployees = [...employees];

  if (selectedFilter === "Active") {
    filteredAndSortedEmployees = employees.filter(
      (employee) => employee.is_active === 1
    );
  } else if (selectedFilter === "In Active") {
    filteredAndSortedEmployees = employees.filter(
      (employee) => employee.is_active === 0
    );
  }

  if (selectedFilter === "Sort By Name") {
    filteredAndSortedEmployees.sort((a, b) =>
      a.employee_full_name.localeCompare(
        b.employee_full_name
      )
    );
  } else if (selectedFilter === "Sort By Employee ID") {
    filteredAndSortedEmployees.sort((a, b) =>
      compareAlphanumeric(
        a.employee_id,
        b.employee_id
      )
    );
  }

  return filteredAndSortedEmployees;
};